import React, { Suspense } from 'react';
import { buscarTotalDeContas } from '../../services/busca-total-de-contas';
import { buscarTotalDePersonagens } from '../../services/busca-total-de-personagens';
import { MenuComponent } from '../index-component/menu-component/menu-component';
import { RodapeComponent } from '../rodape-component/rodape.component';
import './main.component.scss';
import { Outlet } from 'react-router-dom';
import { PainelEsquerdoComponent } from './painel-esquerdo/painel-esquerdo.component';
import { alertService } from '../../services/alertService';
import { withTranslation } from 'react-i18next';
 
class MainComponent extends React.Component<any, any> {

    componentDidMount() {
        const { t } = this.props;

        buscarTotalDeContas()
            .then((data) => this.setState({ totalContas: data }))
            .catch(() => {
                alertService.toast(t("MAIN_FETCH_ACCOUNTS_ERROR"), 'error');
            });

        buscarTotalDePersonagens()
            .then((data) => this.setState({ totalPersonagens: data }))
            .catch(() => {
                alertService.toast(t("MAIN_FETCH_CHARACTERS_ERROR"), 'error');
            });
    }

    render() {
        const { t } = this.props;

        return (
            <div>
                <div className="container main-component">

                    <div className="row conteudo-principal">

                        <div className="col-12 col-lg-4">
                            <PainelEsquerdoComponent />
                        </div>

                        <div className="col-12 col-lg-8">
                            <div className="row">
                                <div className="col-12">
                                    <MenuComponent />
                                </div>
                            </div>

                            <div style={{ marginTop: "2%" }}>
                                <Suspense fallback={<div>{t("MAIN_LOADING")}</div>}>
                                    <Outlet />
                                </Suspense>
                            </div>
                        </div>

                    </div>
                </div>

                <RodapeComponent />
            </div>
        );
    }
}

export default withTranslation()(MainComponent);
